import { DeviceInfo } from "../../../../models/device/device-info";

export class CompleteActivitySummaryData {
    activityId: number;
    requestId: number;

    activityWorkflowTransitionId: number;
    comment: string;

    activityResultIds: number[] = [];
    activityResultName: string;
    completedDateTime: Date;

    devicesToInstall: DeviceInfo[] = [];
    installGeneralDevices: SummaryGeneralDevice[] = [];
    installSimcardDevices: SummarySimcardDevice[] = [];
    uninstallGeneralDevices: SummaryGeneralDevice[] = [];
    uninstallSimcardDevices: SummarySimcardDevice[] = [];
}

export class SummaryGeneralDevice {
    nomenclature: string;
    serialNumber: string;
    partNumber: string;
    deviceConditionName: string;
    validatedInErp: boolean;
}

export class SummarySimcardDevice {
    nomenclature: string;
    deviceModelName: string;
    iccid: string;
    subscriberNumber: string;
    validatedInErp: boolean;
}